import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoreInfoComponent } from './more-info/more-info.component';
import { PremiereBackgroundImageComponent } from './premiere-background-image/premiere-background-image.component';
import { PremiereDescriptionComponent } from './premiere-description/premiere-description.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PremiereTrailerComponent } from './premiere-trailer/premiere-trailer.component';
import { RouterModule } from '@angular/router';
import { MobilePremiereBackgroundComponent } from './mobile-premiere-background/mobile-premiere-background.component';
import { MobilePremiereDescriptionComponent } from './mobile-premiere-description/mobile-premiere-description.component';
import { MobilePremiereTrailerComponent } from './mobile-premiere-trailer/mobile-premiere-trailer.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MixpanelModule } from 'src/app/shared/mix-pane.modul';





@NgModule({
  declarations: [
    MoreInfoComponent,
    PremiereBackgroundImageComponent,
    PremiereDescriptionComponent,
    PremiereTrailerComponent,
    MobilePremiereBackgroundComponent,
    MobilePremiereDescriptionComponent,
    MobilePremiereTrailerComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    SharedModule,
    RouterModule,
    MixpanelModule
  ]
})
export class PremiereDetailsModule { }
